import { useAuthAccountId, useAuthUserAccounts } from './eventSubscribers';

export function useIsCorporateAccount(): boolean {
  const userAccounts = useAuthUserAccounts();
  const accountId = useAuthAccountId();
  return !!userAccounts?.find(account => account.id === accountId)?.name;
}
